export default "__VITE_ASSET__45d689cc__"